<template>
    <div style="display: inline-block">
        <el-dialog :visible.sync="dialog" :close-on-click-modal="false" :before-close="cancel" title="转账" append-to-body
            width="900px" @close="cancel">
            <el-tabs v-model="activeName" type="card">
                <!-- <el-tab-pane name="1" disabled>
          <span slot="label"
            ><i class="iconfontels iconels-saoyisao"></i> 线上付款</span
          >
        </el-tab-pane> -->
                <el-tab-pane name="2">
                    <span slot="label"><i class="iconfontels iconels-kuahangzhanghuduiwaizhuanzhang"></i>
                        对公转账</span>

                    <div class="transfer-accounts-box" v-loading="loading">
                        <div class="transfer-title">
                            应付金额:<span>{{ goods.price }}</span>元
                        </div>
                        <div class="step">
                            <div class="step-info">
                                <i class="iconfontels iconels-shuzi-"></i>
                                <div class="name">
                                    <span>Step1</span>
                                    <span>转账汇款</span>
                                </div>
                            </div>

                            <div class="divider">
                                <div class="line"></div>
                                <i class="el-icon-arrow-right"></i>
                            </div>

                            <div class="step-info">
                                <i class="iconfontels iconels-shuzi-1"></i>
                                <div class="name">
                                    <span>Step2</span>
                                    <span>提交支付凭证给企业客服</span>
                                </div>
                            </div>
                        </div>

                        <div class="acct-info-box">
                            <div class="info">转帐汇款至以下帐户:</div>
                            <div class="acct-info">
                                <div class="block">
                                    <div>
                                        <span class="lable">收款公司:</span>上海咸泰信息科技有限公司
                                    </div>
                                    <div>
                                        <span class="lable">收款账号:</span>1001213909300012764
                                    </div>
                                    <div>
                                        <span class="lable">开户银行:</span>中国工商银行股份有限公司上海市武进路支行
                                    </div>
                                </div>

                                <div class="block">
                                    <div><span class="lable">客服电话:</span>021-80290967</div>
                                    <div style="display: flex;">
                                        <span class="lable">联系在线客服:</span>
                                        <img :src="require('@/assets/images/lxfs.jpg')" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pay-btn-box">
                            <!-- <el-button
                type="primary"
                v-if="!orderId"
                @click="onCreateOrder"
              > 确认支付</el-button> -->
                            <!-- <el-button
                type="primary"
                @click="onClickPay"
              > 我已支付</el-button> -->
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>

            <div slot="footer" class="dialog-footer">
                <span style="color: #909399;float: left;font-size: 14px;">
                    转账成功后，2个工作日内确认到账
                </span>
                <el-button type="primary" class="confirm" v-if="!serialNo" @click="onClickPay">
                    提交订单</el-button>

                <el-button type="text" class="cancel" @click="cancel">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                dialog: false,
                activeName: "2",
                username: localStorage.getItem("BAILIAN-SHIBIE-USERNAME"),
                goods: {},
                serialNo: undefined,
                orgCode: this.$localStorage.getItem("orgCode"),
            };
        },
        methods: {
            onShow(goods, serialNo) {
                this.goods = goods;
                this.serialNo = serialNo;
                this.loading = false;
                this.dialog = true;
            },
            onCreateOrder() {
                this.loading = true;
                this.$axios({
                    url: this.$resource.createTransferOrders,
                    method: "post",
                    data: {
                        goodsId: this.goods.id,
                        oprUser: this.username,
                        orgCode: this.orgCode,
                    },
                }).then((res) => {
                    this.loading = false;
                    const bl = this.$utils.ajaxResponse.call(this, res);
                    if (bl) {
                        this.$message({
                            message: "账单创建成功！",
                            type: "success",
                        });
                        this.dialog = false
                        this.$router.push({
                            path: '/dashboard/userHome/rechargeOrder'
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            },
            onClickPay() {
                const that = this;
                this.$confirm("确认提交订单?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    that.onCreateOrder();
                });
            },
            cancel() {
                this.dialog = false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .el-tabs {
        // box-shadow: 0px 2px 10px rgb(0 58 113 / 21%);
        box-shadow: 0px 2px 10px 0 rgba(0, 58, 113, 0.21);
        border-radius: 5px;
    }

    .el-tabs /deep/ .el-tabs__header>.el-tabs__nav-wrap>.el-tabs__nav-scroll .el-tabs__nav>.is-active {
        border-top: 1px solid;
    }

    .transfer-accounts-box {
        margin: 50px 50px 20px;

        .transfer-title {
            color: #000000;
            text-align: center;
            font-size: 16px;
        }

        .transfer-title span {
            color: #3d7fff;
            font-size: 40px;
            font-weight: 600;
        }

        .step {
            margin: 20px 0px;
            display: flex;
            justify-content: center;

            .step-info {
                display: flex;

                .name {
                    display: flex;
                    line-height: 25px;
                    font-size: 14px;
                    flex-direction: column;
                }
            }

            .divider {
                margin: 0px 10px;
                display: flex;
                align-items: center;

                .line {
                    width: 300px;
                    height: 0px;
                    border: 1px dashed #909399;
                    border-width: 1px 1px 0px 0px;
                }
            }

            .divider i {
                color: #909399;
                font-size: 16px;
                margin: 0px;
            }
        }

        .step i {
            font-size: 45px;
            margin-right: 10px;
        }

        .acct-info-box {
            font-size: 15px;
            margin-top: 40px;

            .info {
                line-height: 30px;
                color: #999999;
            }

            .acct-info {
                display: flex;
                justify-content: space-between;

                .block {
                    line-height: 30px;

                    .lable {
                        color: #999999;
                        margin-right: 5px;
                    }

                    img {
                        width: 70px;
                    }
                }
            }
        }

        .pay-btn-box {
            text-align: center;
            margin: 40px;
        }

        .pay-btn-box button {
            width: 100px;
            padding: 8px;
        }
    }
</style>